module.exports = __webpack_public_path__ + "static/media/insect(40).36e7bb72.PNG";